import { useI18n } from '../i18n';
import { Link, buildLeaderboard } from '../router';
import { Medal, RankBadge } from './RankInsignia';

// 荣誉说明:三种徽记各自的来源 —— 等级(长期累积)/ 每日奖牌(单日夺冠)/ 榜单徽章(霸榜天数)。
// 作为 SEO 正文的一节内嵌在 Game modes 与 FAQ 之间,沿用 .seo-content 的排版,不另起卡片。
export default function HonorsIntro() {
  const { t, lang } = useI18n();
  const h = t.honors;

  return (
    <>
      <h2>{h.title}</h2>
      <p>{h.intro}</p>
      <ul className="seo-honors">
        <li>
          <span className="sh-art">
            <RankBadge level={1} size={30} />
            <RankBadge level={7} size={36} />
            <RankBadge level={14} size={42} />
          </span>
          <span>
            <b>{h.levelT}</b> — {h.levelD}
          </span>
        </li>
        <li>
          <span className="sh-art">
            <Medal board="today" rank={2} size={40} />
            <Medal board="today" rank={1} size={48} />
            <Medal board="today" rank={3} size={40} />
          </span>
          <span>
            <b>{h.dailyT}</b> — {h.dailyD}
          </span>
        </li>
        <li>
          <span className="sh-art">
            <Medal board="streak" rank={1} num={12} size={36} />
            <Medal board="unlimited" rank={2} num={7} size={36} />
            <Medal board="level" rank={3} num={30} size={36} />
          </span>
          <span>
            <b>{h.boardT}</b> — {h.boardD}
          </span>
        </li>
      </ul>
      <p>
        <Link to={buildLeaderboard(lang)}>{h.cta} →</Link>
      </p>
    </>
  );
}
